import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";

import {
  WirelessSubscriptionDetailsGQL,
  WirelessSubscriptionDetailsQuery,
} from "../../../../apis/networkdashboard/graphql/graphql";
import { EMPTY_HEALTH } from "../../../../components/models/HealthIndicator";
import { SubscriptionPageComponent } from "../../../../components/subscription-detail/subscription-page/subscription-page";
import { WirelessSubscriptionDetails } from "../../types";
import { GenericSubscription } from "../generic-subscription";
import { WirelessSubscriptionViewComponent } from "./wireless-subscription-view";

@Component({
  selector: "wireless-subscription",
  templateUrl: "wireless-subscription.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SubscriptionPageComponent, WirelessSubscriptionViewComponent],
})
export class WirelessSubscriptionComponent extends GenericSubscription<
  WirelessSubscriptionDetailsQuery,
  WirelessSubscriptionDetails
> {
  protected query = inject(WirelessSubscriptionDetailsGQL);

  protected override health = computed(() => EMPTY_HEALTH);
  protected override reportedStatus = computed(() => this.health().status);

  protected onQuerySuccess(data: WirelessSubscriptionDetailsQuery): WirelessSubscriptionDetails {
    return data.wirelessDetails;
  }
}
